var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuickMessageEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "82px",
    viewBox: "0 0 115 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icQuickMessageEmptyState") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Views-empty-state",
    transform: "translate(-130.000000, -302.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icQuickMessageEmptyState",
    transform: "translate(130.000000, 303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,41.9047619 C28.3185511,51.6433336 34.4335924,56.4319342 44.3127478,61.1827888 L44.3127478,78.7664382 C44.3127478,79.2181188 44.582135,79.637436 45.0147134,79.852254 C45.2124914,79.9512204 45.4307291,80 45.6475055,80 C45.9032528,80 46.1594873,79.9310519 46.3811351,79.7955008 L67.7504107,66.7239671 C68.6150804,66.7657112 69.4242163,66.8079243 70.2484535,66.8079243 C95.3550507,66.8079243 114.285714,52.4474827 114.285714,33.4051348 C114.285714,14.3604416 95.3550507,0 70.2484535,0 C57.6958857,0 46.6870576,3.58999314 38.8158844,9.56080744 L57.9194819,9.56080744 L40,41.9047619 L26.6666667,41.9047619 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4285714,
    y1: 19.047619,
    x2: 45.7142857,
    y2: 19.047619,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 26.6666667,
    x2: 34.2857143,
    y2: 26.6666667,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4285714,
    y1: 34.2857143,
    x2: 30.4761905,
    y2: 34.2857143,
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    cx: 60.952381,
    cy: 34.2857143,
    r: 3.80952381
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    cx: 76.1904762,
    cy: 34.2857143,
    r: 3.80952381
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    cx: 91.4285714,
    cy: 34.2857143,
    r: 3.80952381
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuickMessageEmptyState);
export default __webpack_public_path__ + "static/media/icQuickMessageEmptyState.0a60e50e0cea0f538a2b7a4c7835083c.svg";
export { ForwardRef as ReactComponent };